module.exports = __webpack_public_path__ + "ac0a3bb7282cb8dad1a4273449a3520c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalHeader/logo_mobile.png
// module id = 1182
// module chunks = 7